export default __webpack_public_path__ + "static/media/selected2.10f91d3b.png";